import { render } from "./CertificatesView.vue?vue&type=template&id=cb5942a0&scoped=true"
import script from "./CertificatesView.vue?vue&type=script&lang=js"
export * from "./CertificatesView.vue?vue&type=script&lang=js"

import "./CertificatesView.vue?vue&type=style&index=0&id=cb5942a0&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5942a0"]])

export default __exports__